import PickupLocationList from "./PickupLocationList";

export default PickupLocationList;